import React from 'react';
import MenuContextProvider from './src/context';
import "@fontsource/lexend";
import "./src/styles/Global.css";

export const wrapRootElement = ({ element }) => {
  return ( 
    <MenuContextProvider>{element}</MenuContextProvider>
  )
}